import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useIncidenceStats } from 'modules/bookkeepers/hooks/IncidenceStatsContext'
import { INHOUSE_INCIDENCE_STATUSES } from 'modules/payroll_bundle/lib/Incidences/Status'
import StatsByStatus from 'modules/payroll_bundle/pages/IncidencesPage/components/_IncidencesPageHeader/_Stats/_ByStatus'

const InHouseStats = () => {
  const incidenceStats = useIncidenceStats()

  return (
    <>
      <StatsByStatus
        stats={incidenceStats}
        status={INHOUSE_INCIDENCE_STATUSES.to_do}
        label={i18n.t('bookkeepers.incidence.status.to_do')}
        hasBorder
      />
      <StatsByStatus
        stats={incidenceStats}
        status={INHOUSE_INCIDENCE_STATUSES.doing}
        label={i18n.t('bookkeepers.incidence.status.doing')}
      />
    </>
  )
}

export default observer(InHouseStats)
